export enum Level {
  TRACE, DEBUG, INFO, SILENT
}
